import styled from 'styled-components';
import CustomCard from '@components/CustomCard';

export const CardContainer = styled(CustomCard)`
  .card-title {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    color: ${({ theme }) => theme.colors.text};

    .card-title-row {
      width: 100%;

      @media (max-width: 620px) {
        justify-content: center;
      }
    }

    .card-title-name {
      @media (max-width: 375px) {
        white-space: break-spaces;
        text-align: center;
      }
    }

    .card-select-filter {
      @media (max-width: 375px) {
        width: 10rem !important;
      }
    }

    .anticon-question-circle {
      svg {
        width: 1.2rem;
        height: 1.2rem;
        fill: ${({ theme }) => theme.colors?.text};
      }
    }

    .ant-tabs {
      padding: 0;
    }

    .ant-tabs-tab {
      margin: 0;

      .ant-tabs-ink-bar {
        padding: 20px;
      }
    }

    .ant-radio-group {
      z-index: 0;
    }

    .ant-radio-button-wrapper {
      margin: 0;
      flex-wrap: wrap;

      span {
        font-weight: normal;
      }
    }

    @media (max-width: 500px) {
      justify-content: center;

      .ant-radio-group {
        margin-top: 16px;
      }
    }
  }

  .ant-card-body {
    padding-top: 16px !important;
    padding-right: 16px !important;
  }

  [data-chart-source-type='G2Plot'] {
    > div {
      z-index: 0;
    }
  }

  .g2-html-annotation {
    opacity: 0.8;
    font-size: 1.4rem !important;
    color: ${({ theme }) => theme.colors.text1} !important;
  }

  .g2-html-annotation + .g2-html-annotation {
    margin-top: 8px !important;
    font-size: 1.8rem !important;
    color: ${({ theme }) => theme.colors.text} !important;
  }

  .g2-tooltip {
    padding: 12px !important;
  }

  .custom-tooltip {
    text-align: center;
    list-style: none;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    margin: 0px !important;
  }

  .g2-tooltip-list-item {
    margin: 0px !important;
  }

  .g2-tooltip-title {
    margin: 0px !important;
  }

  .g2-tooltip-value {
    margin-left: 4px !important;
  }

  .pie-chart {
    background-color: ${({ theme }) => theme.colors.background} !important;
  }

  .ant-row:has(.empty-container) {
    justify-content: center;
    align-items: center;
  }
`;

export const FiltersContainer = styled.div`
  margin: 0 0.4rem 1.56rem 1rem;
  div {
    margin: 0;
  }
`;
